import { render, staticRenderFns } from "./SelectWrapper.vue?vue&type=template&id=0752ff5b&"
import script from "./SelectWrapper.vue?vue&type=script&lang=js&"
export * from "./SelectWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0752ff5b')) {
      api.createRecord('0752ff5b', component.options)
    } else {
      api.reload('0752ff5b', component.options)
    }
    module.hot.accept("./SelectWrapper.vue?vue&type=template&id=0752ff5b&", function () {
      api.rerender('0752ff5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/SelectWrapper.vue"
export default component.exports